import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import { appendGraphQlMajorEntity, findAssociatedMajorEntity } from 'src/utils/utilPlanning';
import ModalConfirm from '../modal/modalConfirm';
import InputUpdate from '../input/inputUpdate';
import InputEmployeeUpdate from '../input/inputEmployeeUpdate';
import TextAreaUpdate from '../input/textareaUpdate';
import DatePickerUpdate from '../input/datepickerUpdate';
import TimePickerUpdate from '../input/timepickerUpdate';

import data_criticity from 'src/data/criticity';
import data_planning_state from 'src/data/planning-state';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiReminderShow = '/api/reminder/show/';
const linkToUser = '/dashboard/user/';

class DisplayReminder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notFound: false,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalReminderCloseOpen: false,
      isModalReminderChangeOpen: false,
      textModal: {
        title: undefined,
        message: undefined,
      },
      title: '____',
      text: '____',
      criticity: '____',
      date: '____',
      timeBeforeAlert: 0,
      isClosed: undefined,
      closingDate: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleReminderChange = this.handleReminderChange.bind(this);
    this.changeReminderState = this.changeReminderState.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.closeReminder = this.closeReminder.bind(this);
    this.openModalReminderChange = this.openModalReminderChange.bind(this);
    this.openModalReminderClose = this.openModalReminderClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleReminderChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let graphKey;

    switch (name) {
      case 'status':
        graphKey = 'state';
        break;
      case 'criticity':
        graphKey = 'criticity';
        break;
    }

    this.openModalReminderChange(graphKey, value);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiReminderShow;
      let graphQL =
        '{ reminder(id:' +
        paramsID +
        '){ id, title, text, criticity, state, closed, closingDate, dateRecall, timeBeforeAlert, dateCreate, creator{ id, user{ id, username } }, assignedEmployee{ id, user{ id, username } } ' +
        appendGraphQlMajorEntity() +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['reminder']) {
              this.setState({
                entity: data['data']['reminder'],
                title: data['data']['reminder']['title'],
                text: data['data']['reminder']['text'],
                majorEntity: findAssociatedMajorEntity(data['data']['reminder']),
                status: data['data']['reminder']['state'],
                criticity: data['data']['reminder']['criticity'],
                dateRecall: data['data']['reminder']['dateRecall'],
                timeBeforeAlert: data['data']['reminder']['timeBeforeAlert'],
                isClosed: data['data']['reminder']['closed'],
                closingDate: data['data']['reminder']['closingDate'],
                dateCreated: data['data']['reminder']['dateCreate'],
                creator: data['data']['reminder']['creator'],
                assignedEmployee: data['data']['reminder']['assignedEmployee'],
              });
            } else {
              // not found
              this.setState({ notFound: true });
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch reminder entity: \n' + error);
          }.bind(this)
        );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    if (this.state.notFound === true || !this.props.match.params.id) return null;

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Fiche Rappel'
        >
          <div className={'appViewNavMenu-alignRight'}>
            {!this.state.isClosed && (
              <button type='button' className='btn btn-sm btn-outline-success' onClick={this.openModalReminderClose}>
                <span className='icon icon-check'>Clôturer</span>
              </button>
            )}
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <InputUpdate
                inputType={'text'}
                inputLabel={'Titre'}
                inputValue={this.state.title}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'title')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              {this.state.majorEntity && (
                <div className='form-group'>
                  <label>{'Associé à ' + this.state.majorEntity.label + ':'}</label>
                  <Link to={this.state.majorEntity.linkTo + this.state.majorEntity.id}>
                    <input
                      name='majorEntity'
                      value={this.state.majorEntity.name}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}

              <DatePickerUpdate
                inputType={'text'}
                inputLabel={'Jour de rappel'}
                inputValue={this.state.dateRecall}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'date', 'dateRecall')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              <TimePickerUpdate
                inputType={'text'}
                inputLabel={'Heure de rappel'}
                inputValue={this.state.dateRecall}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'time', 'dateRecall')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              <InputUpdate
                inputType={'number'}
                inputLabel={'Rappel avant (min)'}
                inputValue={this.state.timeBeforeAlert}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'number', 'timeBeforeAlert')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />

              {this.state.isClosed && (
                <div className='form-group'>
                  <label>Clôturé le</label>
                  <input
                    name='closingDate'
                    value={moment(this.state.closingDate).format('DD-MM-YY à HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
              )}
              <div className='form-group'>
                <label>État</label>
                {!this.state.isClosed ? (
                  <select
                    name='status'
                    value={this.state.status}
                    onChange={this.handleReminderChange}
                    className='form-control'
                  >
                    {data_planning_state ? (
                      Object.entries(data_planning_state).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='status'
                    value={'Clos'}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Criticité</label>
                {!this.state.isClosed ? (
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleReminderChange}
                    className='form-control'
                  >
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='criticity'
                    value={this.state.criticity + '-' + data_criticity[this.state.criticity].fr}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>

              {this.state.assignedEmployee && (
                <InputEmployeeUpdate
                  inputType={'text'}
                  inputLabel={'Employé assigné'}
                  inputValue={this.state.assignedEmployee}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'employee', 'assignedEmployee')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
              )}

              <div className='form-group'>
                <label>Créé le</label>
                <input
                  name='dateCreated'
                  value={moment(this.state.dateCreated).format('DD-MM-YY à HH:mm')}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  readOnly
                />
              </div>

              {this.state.creator && (
                <div className='form-group'>
                  <label>Créateur</label>
                  <Link to={linkToUser + this.state.creator.user.id}>
                    <input
                      name='creator'
                      value={this.state.creator.user.username}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}

              <TextAreaUpdate
                inputType={'text'}
                inputLabel={'Commentaire'}
                inputValue={this.state.text}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'text')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
            </form>
          </div>
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalReminderChangeOpen}
          onSubmit={this.changeReminderState}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalReminderCloseOpen}
          onSubmit={this.closeReminder}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>
      </div>
    );
  }

  openModalReminderChange(graphKey, newState) {
    let modal = {
      title: 'Rappel',
      message: "Vous allez modifiez l'état du rappel",
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalReminderChangeOpen: true,
      reminderChangeGraphKey: graphKey,
      reminderChangeNewState: newState,
    });
  }

  openModalReminderClose() {
    let modal = {
      title: 'Rappel',
      message: 'Vous allez clôturer ce rappel',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalReminderCloseOpen: true,
      appViewNavExtended: false,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalReminderChangeOpen: false,
      isModalReminderCloseOpen: false,
    });
  }

  changeReminderState() {
    if (this.props.match.params.id && this.state.reminderChangeGraphKey && this.state.reminderChangeNewState) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiReminderShow;
      let graphQL =
        'mutation{ reminder(id:' +
        paramsID +
        ',' +
        this.state.reminderChangeGraphKey +
        ':' +
        this.state.reminderChangeNewState +
        ' ){ id, ' +
        this.state.reminderChangeGraphKey +
        ' } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['reminder'][this.state.reminderChangeGraphKey] == this.state.reminderChangeNewState) {
            this.componentDidMount();
            this.props.openToast(true, 'Le rappel a été modifié');
          } else {
            this.props.openToast(false, 'Erreur modification rappel. Veuillez réessayer');
          }
        })
        .catch((rror) => {
          console.log(rror);
        });
    }
  }

  closeReminder() {
    if (this.props.match.params.id) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiReminderShow;
      let graphQL = 'mutation{ reminder(id:' + paramsID + ',closed:true){ id, closed } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['reminder']['closed'] == true) {
              this.componentDidMount();
              this.props.openToast(true, 'Le rappel a été clôturé');
            } else {
              this.props.openToast(false, 'Erreur modification rappel. Veuillez réessayer');
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            console.log(rror);
            this.props.openToast(false, 'Erreur modification rappel. Veuillez réessayer');
          }.bind(this)
        );
    }
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (fieldName === 'dateRecall' && inputType === 'time') {
      let oldDate = moment(this.state.dateRecall);
      newValue = moment({
        year: oldDate.year(),
        month: oldDate.month(),
        day: oldDate.date(),
      })
        .seconds(newValue)
        .format('YYYY-MM-DD HH:mm');
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (fieldName === 'dateRecall' && inputType === 'date') {
      let oldDate = moment(this.state.dateRecall);
      newValue = moment(newValue)
        .add({ hours: oldDate.get('hour'), minutes: oldDate.get('minute') })
        .format('YYYY-MM-DD HH:mm');
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }

    let graphQL = 'mutation { reminder(id:' + this.props.match.params.id + ', ';

    let graphQuery = inputType === 'employee' ? '{ id, user{ id, username } }' : '';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + graphQuery + ' } }';

    let queryURL = apiReminderShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (fieldName === 'dateRecall') {
            data['data']['reminder'][fieldName] = moment(data['data']['reminder'][fieldName]).format(
              'YYYY-MM-DD HH:mm'
            );
          }

          if (fieldName === 'assignedEmployee') {
            data['data']['reminder'][fieldName] = data['data']['reminder'][fieldName]['id'];
          }

          if (data['data']['reminder'][fieldName] == newValue) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            this.componentDidMount();
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE reminder entity');
        }.bind(this)
      );
  }
}

export default withAuth(DisplayReminder);
